(function () {
  'use strict';

  var MAP = {
    'Next slide': 'الشريحة التالية',
    'Previous slide': 'الشريحة السابقة',
    'Go to slide': 'الذهاب إلى الشريحة',
    Feed: 'الخلاصة',
  };

  function translateNode(el) {
    if (!el || el.nodeType !== 1) return;
    ['aria-label', 'title'].forEach(function (attr) {
      var val = el.getAttribute(attr);
      if (val && MAP[val]) el.setAttribute(attr, MAP[val]);
    });
  }

  function translateCartTextNodes(root) {
    if (!root || typeof window.bambeTranslateCartError !== 'function') return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var raw = (node.nodeValue || '').trim();
      if (!raw || !/[A-Za-z]/.test(raw)) continue;
      if (
        !/due to availability|already in your cart|you can only add|maximum quantity/i.test(raw)
      ) {
        continue;
      }
      var translated = window.bambeTranslateCartError(raw);
      if (translated && translated !== raw) {
        node.nodeValue = node.nodeValue.replace(raw, translated);
      }
    }
  }

  function run() {
    document.querySelectorAll('[aria-label], [title]').forEach(translateNode);
    document.querySelectorAll('link[type="application/atom+xml"]').forEach(function (link) {
      if (link.getAttribute('title') === 'Feed') link.setAttribute('title', MAP.Feed);
    });
    translateCartTextNodes(document.body);
  }

  run();
  document.addEventListener('DOMContentLoaded', run);
  var obs = new MutationObserver(function () {
    run();
  });
  if (document.body) {
    obs.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label', 'title'],
    });
  }
  setTimeout(function () {
    obs.disconnect();
  }, 20000);
})();
